import { ButtonProps, IconProps, modal } from 'bold-ui'
import { IconColor } from 'bold-ui/lib/components/Icon/Icon'
import { ModalDepthLevel } from 'bold-ui/lib/components/Modal/Modal'
import React from 'react'

const icons: { [key in ButtonProps['kind']]: IconProps['icon'] } = {
  normal: 'infoCircleOutline',
  primary: 'infoCircleOutline',
  danger: 'exclamationTriangleOutline',
}

type InformationConfigIcon = {
  type?: ButtonProps['kind']
  fill?: IconColor
}

export interface InformationConfig {
  title: React.ReactNode
  body?: React.ReactNode
  type?: ButtonProps['kind']
  icon?: InformationConfigIcon
  onClose?(): any
  depthLevel?: ModalDepthLevel
  manageOverflow?: boolean
  showCloseButton?: boolean
  closeLabel?: string
}

export const information = (config: InformationConfig) => {
  const {
    title = 'Informação',
    body = null,
    type = 'primary',
    icon,
    onClose,
    depthLevel,
    manageOverflow,
    showCloseButton = false,
    closeLabel = 'Fechar',
  } = config

  return modal({
    title,
    icon: {
      name: icons[icon?.type ?? type],
      fill: icon?.fill ?? type,
    },
    size: 'small',
    onClose,
    render: () => body,
    depthLevel,
    actions: showCloseButton ? [{ kind: type, label: closeLabel, onClick: onClose }] : null,
    manageOverflow,
  })
}
